import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, delay } from 'rxjs';
import { environment } from '@environments/environment';
import { CheckEligibilityResponse } from '@models/mips-eligibility-response';


@Injectable({
  providedIn: 'root'
})
export class MipsEligibilityService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}`;

  checkEligibility(
  npi: string,
  performanceYear: number,
  organizationId: number,
  tin: string,
): Observable<CheckEligibilityResponse> {
  const body = {
    npi,
    performanceYear,
    organizationId,
    tin,
  };

  return this.http.post<CheckEligibilityResponse>(
    `${this.apiUrl}/mips/submissions/check-eligibility`,
    body
  );
}


  checkMvpRegistration(
    npi: string,
    performanceYear: number
  ): Observable<{ isRegistered: boolean; registrationDate?: string }> {    
    return this.http.post<{ isRegistered: boolean; registrationDate?: string }>(
      `${this.apiUrl}/eligibility/mvp-registration`,
      { npi, performanceYear }
    );
  }
}